import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';

import { allowedNavigation, entryPathOf } from '@portal/core/layout/navigation';
import { PermissionsService } from './permissions.service';

/**
 * Where signing in lands: the first area this user may open.
 *
 * **A guard rather than a `redirectTo` function, and that is the whole reason this file exists.**
 * Angular resolves redirects while it is *matching* the URL, which happens **before** any guard runs
 * -- so a derived `redirectTo` is asked the question before `authGuard` has restored the session, sees
 * no claims, and sends every user to the refusal page. Found on 2026-08-28 in the browser: the
 * sidebar came up complete while the address said `/no-permission`, which is the two answers
 * disagreeing because they were asked at different moments.
 *
 * A guard on the empty path runs **after** the parent's, and `authGuard` only resolves once the
 * session is in the store -- claims included, since `restore` sets them together with the token.
 *
 * It always answers with a `UrlTree`, so the route never activates and needs nothing to render.
 */
export const startRouteGuard: CanActivateFn = () => {
  const permissions = inject(PermissionsService);
  const router = inject(Router);

  const first = allowedNavigation(required => permissions.hasAll(required))[0];

  return router.parseUrl(first === undefined ? '/no-permission' : `/${entryPathOf(first)}`);
};